import React from 'react';

import InputText from '@common_components/inputs/textInput.component';
import { ColorPickerInput } from '@common_components/inputs/color_picker/colorPickerInput.component';
import SelectInput from '@common_components/inputs/selects/selectInput.component';
import type { MainDataSectionProps } from './chartSectionList.interfaces';

const MainDataSection: React.FC<MainDataSectionProps> = ( {
  t: translate,
  newSetting,
  onChangeField,
  fetchChartUnits,
  fetchManagers,
  fetchChartTypes,
} ) => {
  return (
    <>
      <div className="col-span-2">
        <p className="text-[11px] font-semibold text-gray-700 mb-1">
          {translate( 'translation:main_data_section' )}
        </p>
        <hr className="border-gray-200 mb-2" />
      </div>
      <InputText
        className="w-full"
        label={translate( 'translation:chart_title_placeholder' ) as string}
        labelPosition="top"
        isRequired
        value={newSetting.title}
        onChange={val => { return onChangeField( 'title', val ); }}
      />
      <InputText
        className="w-full"
        label={translate( 'translation:data_name_placeholder' ) as string}
        labelPosition="top"
        isRequired
        value={newSetting.dataName}
        onChange={val => { return onChangeField( 'dataName', val ); }}
      />
      <SelectInput
        className="w-full"
        label={translate( 'translation:graphic_unit' ) as string}
        labelPosition="top"
        isRequired
        fetchOptions={fetchChartUnits}
        selected={newSetting.chartUnitId}
        onSelect={val => { return onChangeField( 'chartUnitId', val ); }}
      />
      <SelectInput
        className="w-full"
        label={translate( 'translation:chart_manager' ) as string}
        labelPosition="top"
        isRequired
        fetchOptions={fetchManagers}
        selected={newSetting.managerId}
        onSelect={val => { return onChangeField( 'managerId', val ); }}
      />
      <SelectInput
        className="w-full"
        label={translate( 'common:type' ) as string}
        labelPosition="top"
        isRequired
        fetchOptions={fetchChartTypes}
        selected={newSetting.type}
        onSelect={val => { return onChangeField( 'type', val ); }}
      />
      <ColorPickerInput
        labelPosition="top"
        label={translate( 'translation:chart_color_placeholder' ) as string}
        isRequired={false}
        color={newSetting.color}
        onChange={val => { return onChangeField( 'color', val ); }}
      />
      {newSetting.type === 'auto_increment_gauge' && (
        <>
          <InputText
            className="w-full"
            label={translate( 'translation:increment_value' ) as string}
            labelPosition="top"
            type="number"
            min={1}
            isRequired
            value={newSetting.incrementValue}
            onChange={val => { return onChangeField( 'incrementValue', String( val ) ); }}
          />
          <InputText
            className="w-full"
            label={translate( 'translation:increment_frequency_days' ) as string}
            labelPosition="top"
            type="number"
            min={1}
            isRequired
            value={newSetting.incrementFrequencyDays}
            onChange={val => { return onChangeField( 'incrementFrequencyDays', String( val ) ); }}
          />
        </>
      )}

    </>
  );
};

export default MainDataSection;
